import * as React from 'react';

import * as styles from './ChatbotOnboardingButtonsLayout.css';

interface IChatbotOnboardingButtonsLayoutProps {
  children: React.ReactNode;
}

export const ChatbotOnboardingButtonsLayout: React.FC<IChatbotOnboardingButtonsLayoutProps> = ({ children }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['inner-container']}>{children}</div>
    </div>
  );
};
